export type LiveNewsItem = {
  time: string;
  category: string;
  title: string;
  excerpt: string;
  img?: string;
};

export const FILTER_PILLS = [
  "全部",
  "港股直擊",
  "香港財經",
  "地產新聞",
  "中國財經",
  "國際財經",
  "時事脈搏",
  "即市股評",
  "重要通告",
  "港交所通告",
];

export const LIVE_ITEMS: LiveNewsItem[] = [
  {
    time: "23:56",
    category: "港股直擊",
    title: "夜期報26850 升1點",
    excerpt:
      "夜市期貨連升，截至晚上約10時27分，2月期指夜市最新報26850點，升1點或0.01%，高水3點，暫錄得成交8050張。",
    img: "/images/category-finance/hk-side-3.png",
  },
  {
    time: "23:56",
    category: "重要通告",
    title: "英皇娛樂酒店置金磚套現9970萬 20年升值逾9倍",
    excerpt:
      "英皇娛樂酒店(00296)公布，以代價9970萬元出售多塊金磚，預期來自出售事項將確認收益約9020萬元。",
    img: "/images/category-finance/cn-side-3.png",
  },
  {
    time: "23:56",
    category: "時事脈搏",
    title: "男子涉嫌行賄運輸署考牌官遭廉署起訴",
    excerpt:
      "廉政公署落案起訴一名男子，控告他涉嫌於昨日下午進行的商用車輛駕駛考試中，以600元人民幣行賄運輸署考牌主任圖獲考試及格。考牌主任拒絕受賄，即時向運輸署滙報事件。",
  },
  {
    time: "23:56",
    category: "中國財經",
    title: "商務部斥歐委會風電調查帶有針對性歧視性",
    excerpt:
      "針對歐委會對中國風電企業啟動調查，中國商務部晚間回應稱，此舉具有明顯針對性和歧視性，相關調查乏化外國補貼，存在立案證據不足、程序不透明等諸多問題，是典型的以公平競爭之名行保護主義之實。",
  },
  {
    time: "23:56",
    category: "國際財經",
    title: "道指漲逾400點 AMD瀉逾15%拖累納指",
    excerpt:
      "美國審期指現市高三個別發展，供應管理協會(ISM)1月非製造業指數高於市場預期，道指在貨幣緊縮好友持下，早段一度指高408點。高見49649點，道進即市歷史高位；納指及標普500指數最多跌近0.8%，納指曾一度跌穿20000點。",
    img: "/images/category-finance/popular-1.png",
  },
  {
    time: "23:56",
    category: "國際財經",
    title: "道指早段升逾300點",
    excerpt: "美國私人企業新增職位錄顯降，道指早段上升逾300點。",
    img: "/images/category-finance/us-side-2.png",
  },
  {
    time: "23:56",
    category: "國際財經",
    title: "消化科技股受壓 道指漲逾100點",
    excerpt: "市場消化科技股受壓消息，道指漲逾100點。",
    img: "/images/category-finance/popular-3.png",
  },
  {
    time: "23:48",
    category: "香港財經",
    title: "金管局：銀行體系結餘維持穩定",
    excerpt:
      "金管局公布，銀行體系總結餘維持於約450億元水平，本港資金流向平穩，港元拆息個別發展，1個月拆息微升至約4.1厘。",
    img: "/images/category-finance/hk-side-3.png",
  },
  {
    time: "23:35",
    category: "港股直擊",
    title: "夜期高水擴至10點 成交逾1.2萬張",
    excerpt:
      "夜市期貨升勢擴大，2月期指夜市報26859點，升10點，高水擴闊至約10點，暫錄得成交12300張，反映外圍氣氛改善。",
  },
  {
    time: "23:20",
    category: "地產新聞",
    title: "新盤周末沽逾八成 發展商加推單位",
    excerpt:
      "新界一手新盤首輪銷售反應理想，周末累沽逾八成單位，發展商即時宣布加推約120伙，部分戶型上調定價約2%。",
    img: "/images/category-finance/cn-side-3.png",
  },
  {
    time: "23:05",
    category: "中國財經",
    title: "人行續淨投放 維護季末流動性",
    excerpt:
      "人民銀行公開市場操作續做淨投放，單日逆回購規模達3500億元，分析指當局有意維護季末資金面平穩，緩解短期流動性壓力。",
  },
  {
    time: "22:52",
    category: "即市股評",
    title: "科技股回吐 分析籲候回調後吸納",
    excerpt:
      "個別重磅科技股午後回吐，拖累指數升幅收窄。有券商分析認為基本面未變，建議投資者待回調後分段吸納優質龍頭。",
    img: "/images/category-finance/popular-1.png",
  },
  {
    time: "22:40",
    category: "港交所通告",
    title: "兩隻新股明起招股 集資逾30億",
    excerpt:
      "港交所披露，兩隻新股將於明日起公開招股，合共集資逾30億元，分別來自醫療科技及消費板塊，招股期至下周三截止。",
  },
  {
    time: "22:18",
    category: "國際財經",
    title: "歐股造好 德國DAX創新高",
    excerpt:
      "歐洲主要股市普遍上揚，受惠企業盈利勝預期，德國DAX指數盤中再創歷史新高，法國CAC及英國富時100指數同步造好。",
    img: "/images/category-finance/us-side-2.png",
  },
];

export type IndexRow = {
  name: string;
  code: string;
  // TradingView symbol used by the embedded chart, e.g. "HSI:HSI" or
  // "SSE:000001". When the row is hovered/clicked the chart switches to
  // this symbol.
  tvSymbol: string;
  spot: string;
  change: string;
  changePercent: string;
  range: string;
  up: boolean;
};

export const LIVE_INDICES: IndexRow[] = [
  {
    name: "恒生指數",
    code: "HSI",
    tvSymbol: "HSI:HSI",
    spot: "18,245.67",
    change: "+125.43",
    changePercent: "+0.69%",
    range: "18,120\n-18,280",
    up: true,
  },
  {
    name: "國企指數",
    code: "HSCEI",
    tvSymbol: "HSI:HSCE",
    spot: "6,234.56",
    change: "-45.23",
    changePercent: "-0.72%",
    range: "6,210\n-6,280",
    up: false,
  },
  {
    name: "紅籌指數",
    code: "CCI",
    tvSymbol: "HKEX:HSCCI",
    spot: "4,414.43",
    change: "+53.73",
    changePercent: "+1.23%",
    range: "4385.76\n-4427.59",
    up: true,
  },
  {
    name: "上證指數",
    code: "SSEC",
    tvSymbol: "SSE:000001",
    spot: "4113.36",
    change: "+47.78",
    changePercent: "+1.18%",
    range: "4093.06\n-4118.44",
    up: true,
  },
  {
    name: "深證成指",
    code: "SZSC",
    tvSymbol: "SZSE:399001",
    spot: "14185.55",
    change: "+278.81",
    changePercent: "+2.01%",
    range: "14060.67\n-14188.43",
    up: true,
  },
];
